/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import ProceduresData from "../../data/proceduresData";
import VerifiedIcon from "@mui/icons-material/Verified";
import Faqs from "../Faqs";
import { useLenis } from "../SmoothScroll";
import { Link } from "react-router-dom";
import ct_outline from "../../assets/images/procedures/ct_outline.png";
import TouchImage from "../../assets/images/procedures/mri_outline_1.png";
import flowchart from "../../assets/images/procedures/flowcahrt_large.svg";
import flowchart_mob from "../../assets/images/procedures/flowchart.svg";
import opne_mri_outline from "../../assets/images/procedures/open_mri_outline.png";
import mammo_outline from "../../assets/images/procedures/mammo_outline.png";
import nuclear_outline from "../../assets/images/procedures/nuclear_medicine.png";

export default function Procedures() {
  const { slug } = useParams();
  const location = useLocation();
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, [location.pathname]);

  const procedures = ProceduresData.find((s) => s.slug === slug);
  if (!procedures) return <p className="text-white">Procedures not found</p>;

  return (
    <div>
      <title>{procedures.seoTitle}</title>
      <meta name="description" content={procedures.seoDescription} />
      <div className="text-black font-sans">
        {/* Hero Section */}
        <div className="relative bg-white md:pt-96 pt-52 pb-52 px-4 sm:px-8">
          {/* Foreground Content */}
          <div className="md:max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start relative ">
            {/* Left Side */}
            <div>
              <h1
                data-aos="fade-right"
                className=" pe-8 md:pe-16 text-3xl md:text-[3rem] lg:text-[3.5rem] xl:text-[5.5rem] font-bold md:leading-[1] text-[#d78558] font-robout"
              >
                {procedures.title}
              </h1>
              <h2
                data-aos="fade-right"
                data-aos-delay="100"
                className=" text-xl md:text-[1.5rem]  mt-7 font-robout w-[80%] lg:w-full"
              >
                {procedures.subTitle}
              </h2>
            </div>
          </div>
        </div>
        {/* Full Width Image */}
        <div className="relative -mt-24">
          <img
            src={procedures.shapedImg}
            alt={procedures.alt}
            className="w-full h-auto object-cover"
          />
        </div>
      </div>

      {/* Introduction Section */}
      <div data-aos="fade-up" className="flex justify-center items-center">
        <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] text-center   xl:py-[10rem] py-16  text-white">
          <div className="xl:text-2xl md:text-xl text-lg  mt-4 lg:px-32 text-center font-robout">
            <p className="font-robout text-[20px] lg:text-[30px] text-white font-bold">
              {procedures.description}
            </p>
          </div>
        </div>
      </div>

      {/* What is ......... ?  */}
      {procedures?.whatIs?.heading && (
        <div data-aos="fade-up" className="flex justify-center items-center">
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 pb-28 xl:px-16 2xl:px-0 text-white">
            <div className="xl:text-5xl text-4xl sm:text-left text-center  flex items-center font-robout font-bold pb-4 lg:pb-0 md:w-11/12 xl:w-4/5 2xl:w-[70%]">
              <h3 className="text-[#d78558]">{procedures?.whatIs?.heading}</h3>
            </div>
            <div className="xl:text-xl md:text-xl  text-lg lg:ps-0 md:px-8 px-4 md:text-left text-center font-robout">
              {procedures.whatIs?.subtitle && (
                <h3 className="text-3xl mb-4 font-bold">
                  {procedures.whatIs.subtitle}
                </h3>
              )}
              <p>{procedures.whatIs?.text}</p>
            </div>
          </div>
        </div>
      )}
      {procedures.slug === "ultrasound" && (
        <div
          data-aos="fade-up"
          className="flex justify-center flex-col items-center pb-10"
        >
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 pb-20 px-4 text-white">
            <div className="xl:text-6xl  text-4xl sm:text-left text-center  flex flex-col gap-4 justify-center  font-robout font-bold pb-4 lg:pb-0 md:w-11/12 xl:w-4/5 2xl:w-[70%]">
              <h3 className="text-[#d78558] w-full">Vascular Ultrasound</h3>
            </div>
            <div className="xl:text-xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4 md:text-left text-center font-robout">
              <p className="text-xl font-normal mb-4 2xl:pl-5">
                At CDC, we also specialize in vascular ultrasound, which
                evaluates blood vessels to detect and monitor arterial and
                venous disease. It is commonly used to:
              </p>{" "}
              <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                {[
                  "Screen for high-risk conditions such as carotid artery disease and abdominal aortic aneurysms.",
                  "Assess circulation in the extremities and diagnose peripheral artery disease (PAD).",
                  "Detect blood clots, varicose veins, and venous insufficiency.",
                  "Monitor vascular health after surgical or interventional procedures.",
                ].map((point, i) => (
                  <li key={i} className="mb-2 flex flex-row gap-4">
                    <span className="flex-shrink-0 text-2xl text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <p className=" md:mb-20 mb-10 md:text-2xl text-xl lg:w-3/5 w-4/5 text-white text-center font-robout">
            Nearly 20 to 30 million Americans are at risk for vascular disease,
            including stroke, peripheral artery disease (PAD), carotid disease,
            and aortic aneurysms. Early detection and accurate monitoring with
            vascular ultrasound help inform appropriate intervention and
            follow-up
          </p>
        </div>
      )}
      {procedures.slug === "low-dose-open-ct-scan" && (
        <div className="flex justify-center items-center">
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 pb-28 xl:px-16 2xl:px-0 text-white">
            <div className="xl:text-[50px] text-4xl flex items-center font-robout font-bold pb-4 lg:pb-0  xl:w-4/5 2xl:w-[70%]">
              <h3 className="text-[#d78558]  w-full lg:text-left text-center">
                Cardiac CT
              </h3>
            </div>
            <div className="xl:text-xl md:text-xl  text-xl lg:ps-0 md:px-8 px-4 lg:text-left text-center flex lg:justify-start justify-center flex-col font-robout">
              <h3 className="text-3xl mb-4 font-bold">
                A Clearer Look at Your Heart{" "}
              </h3>
              <p>
                Cardiac CT creates cross-sectional and 3D images in minutes,
                helping physicians detect coronary narrowing, assess chest pain,
                and evaluate heart valves and structures. Using low-dose
                protocols, patients benefit from detailed images with minimal
                exposure, making it safer even for those requiring repeated
                assessments.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Video If available  */}
      {procedures?.whatIs?.video && (
        <div className="flex justify-center items-center pb-10">
          <div className="2xl:w-4/5 w-[90%]">
            <video
              autoPlay
              muted
              loop
              width="100%"
              className="rounded-3xl h-4/6"
              playsInline
            >
              <source src={procedures?.whatIs?.video} type="video/mp4" />
            </video>
          </div>
        </div>
      )}
      {procedures.slug === "open-mri-scan" && (
        <>
          <div className="flex justify-center items-center lg:mt-24">
            <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 2xl:gap-4 gap-8 lg:mt-24 md:mt-16 mt-8">
              <div className="w-full flex justify-center lg:mb-0 mb-8 items-center">
                <img
                  data-aos="fade-up"
                  src={opne_mri_outline}
                  alt="Get in Touch"
                  className="w-full h-auto max-w-[600px]"
                />
              </div>
              <div
                data-aos="fade-up"
                data-aos-delay="100"
                className="xl:text-[1.5rem] text-white md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal md:text-left text-center font-robout"
              >
                <div className=" xl:text-[40px] text-[#d78558] md:text-4xl text-3xl flex lg:pe-8 items-center text-center font-bold mb-10 font-robout">
                  <h3 data-aos="fade-up">Recommended For </h3>
                </div>
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p className="">
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Diagnostic Needs :{" "}
                      </span>{" "}
                      For conditions that require clear, detailed imaging—such
                      as brain disorders, spine problems, or heart concerns.
                    </p>
                  </li>
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Patient Preferences :{" "}
                      </span>{" "}
                      For people who feel anxious in closed scanners and prefer
                      a more open, relaxed environment.
                    </p>
                  </li>
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Comprehensive Evaluation :{" "}
                      </span>{" "}
                      When doctors need both accuracy in imaging and a
                      patient-friendly experience to support confident diagnosis
                      and treatment.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
      {procedures.slug === "3D-mammography" && (
        <>
          <div className="flex justify-center items-center lg:mt-24">
            <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 2xl:gap-4 gap-8 lg:mt-24 md:mt-16 mt-8">
              <div className="w-full flex justify-center lg:mb-0 mb-8 items-center">
                <img
                  data-aos="fade-up"
                  src={mammo_outline}
                  alt="Get in Touch"
                  className="w-full h-auto max-w-[600px]"
                />
              </div>
              <div
                data-aos="fade-up"
                data-aos-delay="100"
                className="xl:text-[1.5rem] text-white md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal md:text-left text-center font-robout"
              >
                <div className=" xl:text-[40px] text-[#d78558] md:text-4xl text-3xl flex lg:pe-8  items-center text-center font-bold mb-10 font-robout">
                  <h3 data-aos="fade-up">Types of Mammograms</h3>
                </div>
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Screening Mammogram :{" "}
                      </span>{" "}
                      Recommended annually for women from the age of 40, even
                      when no symptoms are present.
                    </p>
                  </li>
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Diagnostic Mammogram :{" "}
                      </span>{" "}
                      Performed when a screening shows an area of concern or
                      when symptoms such as a lump, pain, or nipple changes are
                      noticed.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
      {procedures.slug === "cardiac-general-nuclear-medicine" && (
        <>
          <div className="flex justify-center items-center lg:mt-24">
            <div className="2xl:w-4/5 w-[90%] grid lg:grid-cols-2 2xl:gap-4 gap-8 lg:mt-24 md:mt-16 mt-8">
              <div className="w-full flex justify-center lg:mb-0 mb-8 items-center">
                <img
                  data-aos="fade-up"
                  src={nuclear_outline}
                  alt="Get in Touch"
                  className="w-full h-auto max-w-[600px]"
                />
              </div>
              <div
                data-aos="fade-up"
                data-aos-delay="100"
                className="xl:text-[1.5rem] text-white md:text-[1.125rem] text-[1.125rem] lg:ps-0 md:px-8 px-4 leading-normal md:text-left text-center font-robout"
              >
                <div className=" xl:text-[40px] text-[#d78558] md:text-4xl text-3xl flex lg:pe-8 items-center text-center font-bold mb-10 font-robout">
                  <h3 data-aos="fade-up">How It Works</h3>
                </div>
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Tracer Administration :{" "}
                      </span>{" "}
                      A small dose of a radioactive material combined with a
                      carrier substance is introduced into the body, most often
                      through a vein.
                    </p>
                  </li>
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Targeted Distribution :{" "}
                      </span>{" "}
                      The tracer moves through the bloodstream and collects in
                      specific organs or tissues being studied.
                    </p>
                  </li>
                  <li className="mb-2 flex flex-row  gap-4">
                    <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                      <VerifiedIcon fontSize="30px" />
                    </span>
                    <p>
                      <span className="flex-shrink-0 text-2xl font-bold text-[#d78558]">
                        Imaging Process :{" "}
                      </span>{" "}
                      PET or SPECT scanners detect the tiny radiation signals
                      and convert them into detailed images that reflect how the
                      body is functioning.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}

      {procedures?.paragraphtwo && (
        <div data-aos="fade-up" className="flex justify-center items-center">
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2 py-20 xl:px-16 2xl:px-0 text-white">
            <div className="xl:text-[50px] xl:leading-[3.2rem]  text-4xl md:text-left text-center  flex items-center font-robout font-bold pb-4 lg:pb-0 w-11/12 xl:w-4/5 2xl:w-[70%]">
              <h3 className="text-[#d78558]">
                {procedures?.paragraphtwo?.title}
              </h3>
            </div>
            <div className="xl:text-xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4 md:text-left text-center font-robout">
              {procedures?.paragraphtwo?.description}
            </div>
          </div>
        </div>
      )}
      {procedures?.paragraphthree && (
        <div data-aos="fade-up" className="flex justify-center items-center">
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] grid lg:grid-cols-2 grid-cols-1 gap-2  xl:px-16 2xl:px-0 text-white">
            <div className="xl:text-[50px] xl:leading-[3.2rem]  text-4xl md:text-left text-center  flex items-center font-robout font-bold pb-4 lg:pb-0 w-11/12 xl:w-4/5 2xl:w-[70%]">
              <h3 className="text-[#d78558]">
                {procedures?.paragraphthree?.title}
              </h3>
            </div>
            <div className="xl:text-xl md:text-xl sm:text-lg text-lg lg:ps-0 md:px-8 px-4 md:text-left text-center font-robout">
              {procedures?.paragraphthree?.description}
            </div>
          </div>
        </div>
      )}

      {procedures?.whyCDC?.heading && (
        <div
          data-aos="fade-up"
          className="flex justify-center items-center pt-28"
        >
          <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] flex flex-col  gap-2  2xl:px-0 text-white">
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2   xl:px-8 2xl:px-0  text-white">
              <div className="xl:text-[50px] xl:leading-[3.5rem] text-4xl  md:text-left text-center font-robout flex items-center font-bold pb-4 lg:pb-0 lg:w-[70%] xl:w-4/5">
                <h3
                  data-aos="fade-up"
                  className="text-[#d78558]  md:text-left text-center 2xl:pb-8 pb-4"
                >
                  {procedures?.whyCDC?.heading}
                </h3>
              </div>
              <div className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout">
                {procedures?.whyCDC?.points && (
                  <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                    {procedures?.whyCDC?.points.map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex justify-center items-center mt-20">
        <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] flex flex-col  gap-2 pb-8   2xl:px-0 text-white">
          {/* Benefits fo this.procedures .......... ?  */}

          {procedures.benefits && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 mb-8 xl:px-8 2xl:px-0  text-white">
              <div
                data-aos="fade-up"
                className="xl:text-[50px] leading-[3.5rem] flex items-center  md:text-left text-center  text-4xl font-robout font-bold pb-4 lg:pb-0 lg:w-[70%] xl:w-4/5 2xl:w-[70%]"
              >
                <h3 className="text-[#d78558]  2xl:pb-8 w-full pb-4">
                  {procedures?.benefits?.title}
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                {procedures?.benefits?.points && (
                  <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                    {procedures?.benefits?.points.map((point, i) => (
                      <li key={i} className="mb-2 flex flex-row gap-4">
                        <span className="flex-shrink-0 text-2xl text-[#d78558]">
                          <VerifiedIcon fontSize="30px" />
                        </span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}
          {procedures?.howDoes && (
            <div className="flex justify-center items-center">
              {procedures?.howDoes?.heading ? (
                <div className=" md:pt-12  grid lg:grid-cols-2  gap-8 grid-cols-1   overflow-hidden  relative  lg:py-16 font-robout">
                  <div className="flex flex-col justify-center">
                    <div
                      data-aos="fade-up"
                      className="xl:text-[50px] xl:leading-[3.2rem] text-4xl  md:w-11/12 w-full  md:text-left text-center  font-robout font-bold pb-8 "
                    >
                      <h3 className="text-[#d78558] w-full">
                        {procedures?.howDoes?.heading}
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className=" md:text-xl text-white sm:text-lg text-lg mt-4 lg:pe-12 md:pe-6 text-center md:text-left font-robout"
                    >
                      <p className="my-2 ">{procedures?.howDoes?.text}</p>
                    </div>
                  </div>

                  <div className="w-full flex justify-center  items-center">
                    <img
                      data-aos="fade-up"
                      src={procedures?.howDoes?.image}
                      alt="Get in Touch"
                      className="w-full h-auto max-w-[600px]"
                    />
                  </div>
                </div>
              ) : (
                <div className=" md:pt-12 flex justify-center items-center   overflow-hidden  relative  lg:py-16 font-robout">
                  <div className="w-full flex justify-center  items-center">
                    <img
                      data-aos="fade-up"
                      src={procedures?.howDoes?.image}
                      alt="Get in Touch"
                      className="w-full h-auto"
                    />
                  </div>
                </div>
              )}
            </div>
          )}

          {
            // Just for low-dose-open-ct-scan
            procedures.slug === "low-dose-open-ct-scan" && (
              <>
                <div className="flex justify-center items-center">
                  <div className="3xl:w-4/5 2xl:w-[85%] w-[90%] mt-8 md:py-16 text-center text-white">
                    <div
                      data-aos="fade-up"
                      className="xl:text-[50px] text-4xl  text-left 2xl:px-32 xl:px-16 font-robout font-bold pb-8 "
                    >
                      <h3 className="text-[#d78558]  text-center">
                        Coronary CTA with Cleerly AI
                      </h3>
                    </div>

                    <div className="xl:text-3xl md:text-2xl sm:text-xl text-lg my-4 lg:px-32 text-left font-robout">
                      <p data-aos="fade-up" className="my-2 text-center">
                        How We See Your Heart
                      </p>
                    </div>
                    <div className="xl:text-2xl md:text-xl sm:text-lg text-lg mt-4 lg:px-32 text-left font-robout">
                      <p data-aos="fade-up" className="my-2 text-center">
                        With Coronary CT Angiography powered by Cleerly AI,
                        physicians receive a comprehensive view of coronary
                        health that goes far beyond blockages:
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-2 gap-4  mt-8 mb-20 xl:px-8 2xl:px-0 text-center text-white">
                  <div className="flex flex-col lg:justify-start lg:gap-2 gap-4 justify-center">
                    <div className="text-2xl font-robout font-bold flex items-center  md:justify-start justify-center lg:pb-0 xl:w-4/5 ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Vessel Analysis ≥1.5 mm :
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-4 md:text-left text-center font-robout"
                    >
                      <p>
                        High-resolution algorithms evaluate vessels once too
                        small for standard imaging.
                      </p>
                    </div>

                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        AI Vessel Stitching :
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-4 md:text-left text-center font-robout"
                    >
                      <p>
                        Corrects segmentation errors, reducing false positives
                        and misreads.
                      </p>
                    </div>

                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Comprehensive Plaque Profiling :
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-4 md:text-left text-center font-robout"
                    >
                      <p>
                        Measures total plaque volume and categorizes calcified,
                        non-calcified, and high-risk soft plaque.
                      </p>
                    </div>

                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 w-full ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Validated Against 5+ Gold Standards:
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-2 md:text-left text-center font-robout"
                    >
                      <p>
                        Matches accuracy of invasive tools including IVUS, OCT,
                        NIRS, QCA, and FFR.
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col lg:justify-start lg:gap-2 gap-4 justify-center">
                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Ischemia Evaluation :
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-4 md:text-left text-center font-robout"
                    >
                      <p>
                        Cleerly ISCHEMIA integrates plaque, stenosis, and vessel
                        morphology to predict blood flow limitations—without CFD
                        assumptions.
                      </p>
                    </div>
                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 w-full ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Prognostic Value:
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-2 md:text-left text-center font-robout"
                    >
                      <p>
                        Provides risk projections years into the future, helping
                        physicians prevent heart attacks before they happen.
                      </p>
                    </div>
                    <div className=" text-2xl font-robout font-bold flex items-center md:justify-start justify-center lg:pb-0 xl:w-4/5 w-full ">
                      <h3
                        data-aos="fade-up"
                        className="text-[#d78558] md:text-left text-center pb-2"
                      >
                        Efficient Workflow :
                      </h3>
                    </div>
                    <div
                      data-aos="fade-up"
                      className="xl:text-xl md:text-xl sm:text-lg text-lg lg:w-4/5 pb-2 md:text-left text-center font-robout"
                    >
                      <p>
                        Produces comprehensive, vessel-level reports in ~1.3
                        hours, with side-by-side comparisons for disease
                        tracking over time.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-center items-center">
                  <div className=" md:pt-12    overflow-hidden  relative  lg:py-16 font-robout">
                    <div className="w-full flex justify-center  items-center">
                      <img
                        data-aos="fade-up"
                        src={ct_outline}
                        alt="Get in Touch"
                        className="w-full h-auto "
                      />
                    </div>
                  </div>
                </div>
                <div className="flex justify-center items-center py-20">
                  <img
                    src={flowchart}
                    className="hidden md:block"
                    alt="flowcahrt"
                  />
                  <img
                    src={flowchart_mob}
                    className="block md:hidden w-auto h-auto"
                    alt="flowcahrt"
                  />
                </div>
              </>
            )
          }
          {/* Preparations  */}

          <div className="flex justify-center  pt-12 pb-4 items-center">
            <div
              data-aos="fade-up"
              className="3xl:w-4/5 2xl:w-[85%] w-[90%] text-center text-white"
            >
              <div className="xl:text-[50px] text-4xl xl:leading-[3.2rem] text-left 2xl:px-32 xl:px-16 font-robout font-bold pb-8 ">
                <h3 className="text-[#d78558]  text-center">
                  {procedures?.preparation?.title}
                </h3>
              </div>
            </div>
          </div>
          {procedures?.preparation?.before && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2   mt-16 mb-8 xl:px-8 2xl:px-0  text-white">
              <div className="xl:text-[50px]   text-3xl flex items-center  font-robout md:w-4/5 font-bold pb-4 lg:pb-0  ">
                <h3
                  data-aos="fade-up"
                  className="text-[#d78558] sm:text-left xl:leading-[3.2rem] text-center w-full 2xl:pb-8 pb-4"
                >
                  {procedures.slug === "ultrasound" ? (
                    <>
                      <p className="">
                        ULTRASOUND <br></br>
                        <span className="text-xl">
                          {" "}
                          ABDOMEN/ABDOMINAL DOPPLER/GALLBLADDER{" "}
                        </span>
                      </p>
                    </>
                  ) : (
                    <span>{procedures?.preparation?.before?.title}</span>
                  )}
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  {procedures?.preparation?.before?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* During Scan Preparation */}
          {procedures?.preparation?.during && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 xl:my-16 lg:my-12 my-6 xl:px-8 2xl:px-0  text-white">
              <div className="  text-3xl flex items-center font-robout font-bold pb-4 lg:pb-0 xl:w-4/5 ">
                <h3
                  data-aos="fade-up"
                  className="text-[#d78558] xl:text-[50px]  xl:leading-[3.2rem] md:text-left text-center w-full 2xl:pb-8 pb-4"
                >
                  {procedures?.preparation?.during?.title}
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  {procedures?.preparation?.during?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {/* After Scan Preparation */}
          {procedures?.preparation?.after && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2  sm:mb-8 xl:px-8 2xl:px-0  text-white">
              <div
                data-aos="fade-up"
                className="flex items-center  text-3xl font-robout font-bold pb-4 lg:pb-0  xl:w-4/5 "
              >
                <h3 className="text-[#d78558] xl:text-[50px] xl:leading-[3.2rem]  md:text-left text-center w-full 2xl:pb-8 pb-4">
                  {procedures.slug === "pet-ct-scan" ? (
                    <>
                      <p className="">
                        BRAIN AMYLOID PET/CT <br></br>
                        <span className="text-xl">
                          {" "}
                          FOR ALZHEIMER’S DISEASE (VIZAMYL){" "}
                        </span>
                      </p>
                    </>
                  ) : (
                    <span>{procedures?.preparation?.after?.title}</span>
                  )}
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  {procedures?.preparation?.after?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {procedures.slug === "pet-ct-scan" && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 lg:pt-0 pt-8 sm:mb-8 xl:px-8 2xl:px-0  text-white">
              <div className="xl:text-[50px] text-3xl flex items-center font-robout font-bold pb-4 lg:pb-0  ">
                <h3
                  data-aos="fade-up"
                  className="text-[#d78558] md:text-left text-center w-full 2xl:pb-8 pb-4"
                >
                  <p className="">
                    PET/CT NEUROENDOCRINE<br></br>{" "}
                    <span className="text-xl"> (NETSPOT) </span>
                  </p>
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  {procedures?.preparation?.before?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {procedures.slug === "pet-ct-scan" && (
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-2 lg:pt-0 pt-8 sm:mb-8 xl:px-8 2xl:px-0  text-white">
              <div className="xl:text-[50px]  text-xl flex items-center font-robout font-bold pb-4 lg:pb-0  xl:w-4/5 ">
                <h3
                  data-aos="fade-up"
                  className="text-[#d78558] md:text-left text-center w-full 2xl:pb-8 pb-4"
                >
                  <p className="">
                    PROSTATE PSMA PET/CT <br></br>{" "}
                    <span className="text-xl"> (POSLUMA)</span>
                  </p>
                </h3>
              </div>
              <div
                data-aos="fade-up"
                className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
              >
                <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                  {procedures?.preparation?.before?.points.map((point, i) => (
                    <li key={i} className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {procedures.slug === "cardiac-general-nuclear-medicine" && (
            <>
              <div className="grid lg:grid-cols-2 grid-cols-1 gap-2  pt-8 sm:mb-8 xl:px-8 2xl:px-0  text-white">
                <div className="text-3xl font-robout font-bold  flex items-center    xl:w-4/5 ">
                  <h3
                    data-aos="fade-up"
                    className="text-[#d78558] text-4xl  md:text-left text-center w-full "
                  >
                    Important Note for PET/Nuclear Medicine Tests:
                  </h3>
                </div>
                <div
                  data-aos="fade-up"
                  className="xl:text-xl md:text-xl sm:text-lg text-lg  2xl:px-8 px-4  lg:text-left text-center font-robout"
                >
                  <ul className=" text-left mt-4 2xl:pl-5 font-robout">
                    <li className="mb-2 flex flex-row gap-4">
                      <span className="flex-shrink-0 text-2xl text-[#d78558]">
                        <VerifiedIcon fontSize="30px" />
                      </span>
                      <span>
                        The radiopharmaceuticals used for these tests are
                        custom-ordered specifically for your appointment and
                        cannot be canceled or returned within 24 hours of your
                        scheduled exam. Therefore, cancellations or rescheduling
                        for these procedures must be made more than 24 hours in
                        advance to avoid potential charges.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="flex justify-center pt-8 pb-8 items-center">
        <div className="2xl:w-4/5 w-[90%] xl:px-16 2xl:px-0 text-white">
          <Faqs faqs={procedures?.faqs} />
        </div>
      </div>
      <div>
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center 2xl:px-16 xl:px-10 lg:px-8 md:px-5 max-w-[80%] mx-auto py-32">
          {/* Left side content */}
          <div className="w-full flex flex-col md:justify-start justify-center">
            <h2 className="text-3xl md:text-4xl lg:text-5xl md:text-left text-center font-bold mb-8 text-[#d78558] capitalize">
              Schedule your Scan today
            </h2>
            <p className="text-lg md:text-xl md:text-left text-center text-gray-200 mb-6">
              {procedures?.cta?.description}
            </p>
            <h5 className="text-xl md:text-2xl font-semibold mb-8 md:text-left text-center text-[#d78558]">
              Give us a call at:{" "}
              <Link
                to="tel:3527959200"
                aria-label="Phone Number"
                className="text-[#d78558] hover:underline  hover:text-[#fd6b6b]"
              >
                (352) 450-8062
              </Link>
            </h5>

            <Link
              data-aos="fade-right"
              to="/contact"
              aria-label="Contact"
              className="group relative inline-flex md:h-14 tracking-widest items-center rounded-full md:w-80 text-center md:px-10 p-4 md:py-10 text-lg md:text-xl font-semibold text-white bg-transparent overflow-hidden"
            >
              <span className="absolute inset-0 rounded-full bg-[#fd6b6b] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#fd6b6b] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>
              <span className="relative w-full">
                <span className=" text-center w-full  group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  Book an Appointment
                </span>
                <span className="absolute top-0 left-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  Book an Appointment
                </span>
              </span>
            </Link>
          </div>

          {/* Right side image */}
          <div className="w-full flex justify-center lg:mt-0 mt-20">
            <img
              src={TouchImage}
              alt="Get in Touch"
              className="w-full h-auto max-w-[500px]"
            />
          </div>
        </section>
      </div>
    </div>
  );
}
